import React, { Component } from 'react';
import  './Background.css';
import jQuery from 'jquery';

class Background extends Component {
  render() {
    return (
      <div id="Background" className="BackgroundWrapper">
        <div id="Comics" className="Background"></div>
        <div id="ScienceFiction" className="Background"></div>
        <div id="Fantasy" className="Background"></div>
        <div id="Anime" className="Background"></div>
      </div>
    );
  }
}

jQuery('.Background').css('margin-top',''+(window.innerHeight)+'px');
console.log('© 2017 Onur Sahin Senturk');

export default Background;



// WEBPACK FOOTER //
// ./src/components/Background/Background.js